import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root"
})
export class ToastrMessageService {
  constructor(private toastr: ToastrService) {}

  showSuccess(message): void {
    this.toastr.success(message);
  }

  showProcessing(message): void {
    this.toastr.info(message);
  }

  showError(message): void {
    if (!(typeof message === "string")) {
      for (var key in message) {
        this.toastr.error(JSON.stringify(message[key]));
        return;
      }
    } else {
      this.toastr.error(message);
    }
  }

  showWarning(message) {
    this.toastr.warning(message);
  }

  showHTMLErrorMessage(message, title?:any){
    this.toastr.error(message, title, {
      enableHtml :  true
    })
  }
  showProcessingTillOver(message: string, title?: string, options?: any): any {
  return this.toastr.info(message, title || '', {
    timeOut: 0,           // Sticky by default
    closeButton: true,
    tapToDismiss: false,
    disableTimeOut: true,
    ...options            // Allow override
  });
}

clear(toastId?: number): void {
  this.toastr.clear(toastId);
}


}
